export default __webpack_public_path__ + "static/media/FastFood.67c75658.MP4";